import { IDeleteEventoUseCase } from "../../../presentation/useCases/delete/delete_evento_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * DeleteEventoUseCase
 */

export class DeleteEventoUseCase implements IDeleteEventoUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async deleteEvento(idEvento: number): Promise<void> {
    await this.repository.deleteEvento(idEvento);
  }
}